import { render, staticRenderFns } from "./orders-details-page-main-actions.vue?vue&type=template&id=72e97b30"
import script from "./orders-details-page-main-actions.vue?vue&type=script&lang=js"
export * from "./orders-details-page-main-actions.vue?vue&type=script&lang=js"
import style0 from "./orders-details-page-main-actions.vue?vue&type=style&index=0&id=72e97b30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports